import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    ViewChild,
} from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { RiskReportingFeature } from "@features/RiskReportingFeature";

interface NavItem {
    label: string;
    icon: string;
    routerLink: string[];
    feature?: string;
}

@UntilDestroy()
@Component({
    selector: "app-mobile-bottom-nav",
    templateUrl: "./mobile-bottom-nav.component.html",
    styleUrls: ["./mobile-bottom-nav.component.scss"],
})
export class MobileBottomNavComponent implements AfterViewInit {
    @ViewChild("navScroll")
    navScrollRef?: ElementRef<HTMLElement>;

    fadeLeft = false;
    fadeRight = false;

    readonly navItems: NavItem[] = [
        { label: "Home", icon: "home", routerLink: ["/home"] },
        { label: "Forms", icon: "forms", routerLink: ["/assessments"] },
        {
            label: "Performance",
            icon: "performance",
            routerLink: ["/performance"],
        },
        {
            label: "SRM",
            icon: "srm",
            routerLink: ["/risk-management"],
            feature: RiskReportingFeature.key,
        },
        { label: "Assurance", icon: "assurance", routerLink: ["/assurance"] },
        { label: "Promotion", icon: "promotion", routerLink: ["/promotions"] },
        { label: "Policy", icon: "policy", routerLink: ["/policies"] },
        { label: "Documents", icon: "documents", routerLink: ["/manuals"] },
        { label: "Account", icon: "account", routerLink: ["/profile"] },
    ];

    ngAfterViewInit() {
        this.updateFade();
    }

    @HostListener("window:resize")
    onWindowResize() {
        this.updateFade();
    }

    onScroll(event: Event) {
        const el = event.target as HTMLElement;
        this.applyFade(el);
    }

    private updateFade() {
        const el = this.navScrollRef?.nativeElement;
        if (el) {
            this.applyFade(el);
        }
    }

    private applyFade(el: HTMLElement) {
        const scrollLeft = el.scrollLeft;
        const maxScroll = el.scrollWidth - el.clientWidth;
        this.fadeLeft = scrollLeft > 5;
        this.fadeRight = maxScroll > 5 && scrollLeft < maxScroll - 5;
    }
}
